<template>
  <v-container class="container-fluid">
    <v-card class="pa-3">
      <v-card-title>
        <span class="title font-weight-medium">Contato Administradores</span>
        <v-spacer></v-spacer>
        <v-text-field v-model="search" append-icon="search" label="Pesquisar" single-line hide-details></v-text-field>
      </v-card-title>
      <v-data-table :headers="headers" :items="adms" :search="search" item-key class="elevation-1">
        <template v-slot:item=" { item }">
          <tr>
            <td>{{ item.clientUser[0] ? item.clientUser[0].client.name : item.clientUser }}</td>
            <td>{{ item.name }}</td>
            <td>{{ item.phone }}</td>
            <td>{{ item.email }}</td>
          </tr>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import UserController from "../../controllers/UserController";

export default {
  created(){
    this.getAdms()
  },

  data() {
    return {
      headers: [
        { text: "Condomínio", value: "clientUser[0].client.name" },
        { text: "Nome", value: "name" },
        { text: "Telefone", value: "phone" },
        { text: "Email", value: "email" }
      ],
      adms: [],
      search: "",
      userController: new UserController(this.$resource)
    };
  },

  methods:{
    async getAdms(){
      let res = await this.userController.getAllAdms()
      this.adms = res
    }
  }
};
</script>
